module.exports = ".side-image {\r\n  padding-top: 50px;\r\n}\r\n\r\nh1 {\r\n  color: #0a8ae1;\r\n}\r\n"